<fui-rows [formGroup]="editService.formGroup">
    <fui-row>
        <fui-two-columns>
            <fui-column *ngIf="editService.editMode === EditMode.ADD">
                <fui-prepend-field>
                    <fui-tandem-field>
                        <ng-container>
                            <fui-radio-control [(ngModel)]="memberNoAuto" [equivalent]="true"
                                               [ngModelOptions]="{standalone: true}"
                                               [label]="'wbo.member.edit.field.auto.label'"></fui-radio-control>
                            <fui-radio-control [(ngModel)]="memberNoAuto" [equivalent]="false"
                                               [ngModelOptions]="{standalone: true}"
                                               [label]="'wbo.member.edit.field.specify.label'"></fui-radio-control>
                        </ng-container>
                    </fui-tandem-field>
                    <fui-append-field>
                        <wbo-text-edit-control formControlName="memberNo" [(ngModel)]="model.data.memberNo"
                                               [overrideRequired]="!memberNoAuto"
                                               [readonly]="memberNoAuto"></wbo-text-edit-control>
                        <wbo-entity-discontinued-edit-control formControlName="discontinued"
                                                              [(ngModel)]="model.data.discontinued"></wbo-entity-discontinued-edit-control>
                    </fui-append-field>
                </fui-prepend-field>
            </fui-column>
            <fui-column *ngIf="editService.editMode !== EditMode.ADD">
                <fui-append-field>
                    <wbo-text-edit-control formControlName="memberNo" [(ngModel)]="model.data.memberNo"
                                           [readonly]="true"></wbo-text-edit-control>
                    <wbo-entity-discontinued-edit-control formControlName="discontinued"
                                                          [(ngModel)]="model.data.discontinued"></wbo-entity-discontinued-edit-control>
                </fui-append-field>
            </fui-column>
            <fui-column formGroupName="membershipType">
                <wbo-membership-type-single-select-edit-control [objectValue]="model.data.membershipType"
                                                                formControlName="membershipTypeId"
                                                                [(ngModel)]="model.data.membershipType.membershipTypeId"></wbo-membership-type-single-select-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row>
        <fui-two-columns>
            <fui-column><wbo-text-edit-control formControlName="memberCardNo"
                                               [(ngModel)]="model.data.memberCardNo"></wbo-text-edit-control></fui-column>
            <fui-column><wbo-date-edit-control formControlName="joiningDate"
                                               [(ngModel)]="model.data.joiningDate"></wbo-date-edit-control></fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row [label]="'wbo.member.edit.label.pricing'">
        <fui-two-columns>
            <fui-column>
                <wbo-price-level-single-select-edit-control [objectValue]="model.data.pricingPriceLevel"
                                                            formControlName="priceLevelId"
                                                            [(ngModel)]="model.data.priceLevelId"></wbo-price-level-single-select-edit-control>
            </fui-column>
            <fui-column>
                <wbo-discount-single-select-edit-control [objectValue]="model.data.pricingDiscount"
                                                         formControlName="discountId"
                                                         [(ngModel)]="model.data.discountId"></wbo-discount-single-select-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row>
        <fui-two-columns formGroupName="memberRenewal">
            <fui-column>
                <wbo-date-edit-control formControlName="startDate"
                                       [(ngModel)]="model.data.memberRenewal.startDate"></wbo-date-edit-control>
            </fui-column>
            <fui-column>
                <wbo-date-edit-control formControlName="expiryDate"
                                       [(ngModel)]="model.data.memberRenewal.expiryDate"></wbo-date-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row>
        <fui-two-columns>
            <fui-column formGroupName="chargeAccount">
                <wbo-account-single-select-edit-control formControlName="accountId"
                                                        [(ngModel)]="model.data.chargeAccount.accountId"></wbo-account-single-select-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row [label]="'wbo.member.edit.label.memberDetails'">
        <fui-column formGroupName="contact">
            <wbo-contact-edit [formGroupContact]="editService.formGroup.controls['contact']"
                              [contact]="model.data.contact"></wbo-contact-edit>
        </fui-column>
    </fui-row>
</fui-rows>
